import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
interface InvestorSlide9Props {
  isDark?: boolean;
}
export function InvestorSlide9({
  isDark = false
}: InvestorSlide9Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const competitors = [{
    type: 'General EAPs',
    examples: 'Lyra, Spring Health',
    gap: 'Not leadership-focused; generic matching',
    icon: X
  }, {
    type: 'Coaching Platforms',
    examples: 'BetterUp, CoachHub',
    gap: 'Assessment-agnostic; disconnected from care',
    icon: X
  }, {
    type: 'Engagement Surveys',
    examples: 'Culture Amp, Lattice',
    gap: 'Measure engagement, not health; no support',
    icon: X
  }, {
    type: 'Executive Coaching',
    examples: 'Traditional Firms',
    gap: 'Expensive, unscalable, not data-driven',
    icon: X
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-395">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-396">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-397">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-398">
            Competitive Landscape
          </h1>
          <p className={`text-lg sm:text-2xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-399">
            The only platform integrating assessment, development, and care
            specifically for leaders.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16" data-id="element-400">
          {competitors.map((comp, idx) => <motion.div key={idx} variants={itemVariants} className={`p-6 sm:p-8 rounded-2xl flex items-start gap-4 ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige'}`} data-id="element-401">
              <div className={`p-2 rounded-full flex-shrink-0 ${isDark ? 'bg-red-500/20 text-red-400' : 'bg-red-100 text-red-500'}`} data-id="element-402">
                <X className="w-5 h-5" data-id="element-403" />
              </div>
              <div data-id="element-404">
                <h3 className={`text-lg font-bold mb-1 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-405">
                  {comp.type}
                </h3>
                <p className={`text-xs uppercase tracking-wide mb-2 ${isDark ? 'text-white/50' : 'text-heliona-text-gray/70'}`} data-id="element-406">
                  {comp.examples}
                </p>
                <p className={`text-sm ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-407">
                  {comp.gap}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div variants={itemVariants} className={`p-8 sm:p-10 rounded-3xl text-center relative overflow-hidden ${isDark ? 'bg-heliona-mint/10 border border-heliona-mint/30' : 'bg-heliona-mint/10 border border-heliona-mint/30'}`} data-id="element-408">
          <div className="flex flex-col items-center relative z-10" data-id="element-409">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 ${isDark ? 'bg-heliona-mint text-heliona-navy' : 'bg-heliona-mint-dark text-white'}`} data-id="element-410">
              <Check className="w-6 h-6" data-id="element-411" />
            </div>
            <h3 className={`text-2xl font-bold mb-2 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-412">
              The Heliona Moat
            </h3>
            <p className={`text-lg max-w-2xl mx-auto ${isDark ? 'text-white/90' : 'text-heliona-text-gray'}`} data-id="element-413">
              Proprietary psychometric assessment (Helium Score) + Integrated
              care pathways + Leadership-specific content
            </p>
          </div>
        </motion.div>
      </div>
    </motion.div>;
}